/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import Unique from 'toolbox/unique';
import {UI} from "../../UIGenerator.jsx";
import NotificationLog from "./NotificationLog.jsx";

function NotificationsDialog() {
    const open = () => {
        UI.drawer(Unique.newInternalId(), (state, setState, close) => (
            <div className={"mt-3"}>
                <NotificationLog/>
            </div>
        ), {title: `Notifications`, width: 'max-w-md'}).open();
    };

    open();
}

export default NotificationsDialog;